export default {
    type: 'image-carousel',
    name: 'Image Carousel',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleImageCarousel',
            loader: () => import('./ModuleImageCarousel')
        },
        form: {
            name: 'ModuleImageCarouselForm',
            loader: () => import('./ModuleImageCarouselForm')
        }
    }
};
